<template>
  <!-- 顶部下载提示条 -->
  <van-row justify="center" v-if="installShow">
    <van-col :span="24">
      <div id="downGameBox" class="download-tip-container">
        <div class="tip-add-screen">
          <div class="tip-box">
            <div class="tip-card">
              <img
                src="https://play.handzonegame.com/img/common/xz.png"
                class="tip-icon"
              />
              <span class="tip-text">下载到桌面</span>
            </div>
          </div>
        </div>
      </div>
    </van-col>
  </van-row>

  <!-- iOS 底部引导弹窗 -->
  <van-row justify="center">
    <van-col :span="24">
      <van-popup
        v-model:show="showBottom"
        round
        position="bottom"
        style="height: 46%;"
      >
        <div class="popup-header">
          <img
            src="https://play.handzonegame.com/img/icons/apple-touch-icon-152x152.png"
            class="app-icon"
          />
          <div class="header-info">
            <div class="title">快速添加桌面应用</div>
            <div class="sub-title">便捷启动 · 全屏体验</div>
          </div>
          <div class="close-btn" @click="closeBottom">
            <img src="https://play.handzonegame.com/img/icons/close.png" />
          </div>
        </div>

        <div class="popup-content">
          <van-swipe :autoplay="3000" @change="onChange" indicator-color="#12cdb0">
            <van-swipe-item>
              <img
                src="http://down1.msshuo.cn/x7sy/app/opera/i18n_language/content_file/1728358253829_1724320575853_tutorials_GIF1.gif"
                class="guide-gif"
              />
            </van-swipe-item>
            <van-swipe-item>
              <img
                src="http://down1.msshuo.cn/x7sy/app/opera/i18n_language/content_file/1728358373468_1724323437526_tutorials_GIF2.gif"
                class="guide-gif"
              />
            </van-swipe-item>
            <van-swipe-item>
              <img
                src="https://down1.msshuo.cn/x7sy/app/opera/i18n_language/content_file/1728358440834_1724323536190_tutorials_GIF3.gif"
                class="guide-gif"
              />
            </van-swipe-item>
          </van-swipe>

          <div class="step-label">{{ stepNumber }}</div>
        </div>
      </van-popup>
    </van-col>
  </van-row>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { sendEvent } from "@/service/tiktokEvent";

export default {
  setup() {
    const state = reactive({
      installShow: true,
      showBottom: false,
      stepNumber: "第一步",
    });

    // 点击下载到桌面
    const initDownloadClick = () => {
      const el = document.getElementById("downGameBox");
      if (!el) return;

      el.addEventListener("click", () => {
        const sys = getSystemType();

        if (sys === "h5" && window.prom) {
          window.prom.prompt();
          window.prom.userChoice.then((res) => {
            if (res.outcome === "accepted") {
              el.style.display = "none";
            }
          });
        }

        if (sys === "ios") {
          state.showBottom = true;
        }

        // 埋点
        sendEvent({
          eventName: "ClickDownload",
          eventTime: Math.round(Date.now() / 1000).toString(),
          properties: { description: "用户点击了下载" },
        });
      });
    };

    // 获取系统类型
    const getSystemType = () => {
      const u = navigator.userAgent;
      const isAndroid = /Android|Linux/.test(u);
      const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(u);
      if (isAndroid) return "android";
      if (isIOS) return "ios";
      return "h5";
    };

    // 轮播切换
    const onChange = (index) => {
      const steps = ["第一步", "第二步", "第三步"];
      state.stepNumber = steps[index] || "第一步";
    };

    // 关闭弹窗
    const closeBottom = () => {
      state.showBottom = false;
    };

    onMounted(() => {
      initDownloadClick();
      if (getSystemType() === "android") {
        state.installShow = false;
      }
    });

    return {
      ...toRefs(state),
      onChange,
      closeBottom,
    };
  },
};
</script>

<style scoped>
/* 下载提示条 */
.download-tip-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
  z-index: 999;
  display: flex;
  justify-content: center;
}

.tip-add-screen {
  font-size: 0.37rem;
  color: #fff;
}

.tip-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 1.07rem;
  padding: 0 0.43rem;
  background: linear-gradient(90deg, #12cdb0, #12cd80);
  box-shadow: 0 0 0.27rem 0 rgba(16, 199, 171, 0.58);
  border-radius: 0.53rem;
  white-space: nowrap;
}

.tip-icon {
  width: 0.48rem;
  height: 0.55rem;
}

.tip-text {
  font-size: 0.37rem;
  color: #fff;
}

/* 弹窗头部 */
.popup-header {
  margin: 0.64rem;
  margin-bottom: 0.53rem;
  display: flex;
  align-items: center;
  position: relative;
}

.app-icon {
  width: 1.07rem;
  height: 1.07rem;
  margin-right: 0.27rem;
  border-radius: 8px;
}

.header-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  font-size: 0.4rem;
  color: #333;
  font-weight: 700;
  line-height: 1.4;
}

.sub-title {
  font-size: 0.32rem;
  color: #999;
  line-height: 1.4;
  margin-top: 4px;
}

.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.12rem;
  height: 1.12rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn img {
  width: 0.37rem;
  height: 0.37rem;
}

/* 弹窗内容 */
.popup-content {
  position: relative;
  margin: 0 0.64rem;
  width: 8.72rem;
  height: 4.91rem;
  border-radius: 0.32rem;
  overflow: hidden;
}

.guide-gif {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.32rem;
}

.step-label {
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 0.19rem;
  height: 0.53rem;
  background: linear-gradient(270deg, #12cdb0, #12cd80);
  border-radius: 0.27rem 0 0.27rem 0;
  font-size: 0.29rem;
  color: #fff;
  font-weight: 700;
  line-height: 0.53rem;
  z-index: 10;
}
</style>